import type { QueryDocumentSnapshot, DocumentData } from 'firebase/firestore'
import {
  getFirebaseDb,
  pathDoc,
  pathCollection,
  query,
  orderBy,
  limit,
  getDoc,
  getDocs,
  setDoc,
  addDoc,
  onSnapshot,
  startAfter,
  serverTimestamp
} from '@/infra/firebase/firestore'
import {
  BACKUP_QUERY_LIMIT_NUM,
  CONFIG_DOCUMENT_ID,
  SITE_ID
} from './constants'

/** Omikuji / postcard / user config methods */
export const userDataMethods = {
  async addOmikujiLog(this: any, omikuji: unknown) {
    if (!this.isAuthenticated) {
      console.log('not authenticated, addOmikujiLog skipped')
      return
    }
    if (!omikuji) {
      this.$message({
        message: 'おみくじデータがありません',
        type: 'error'
      })
      return
    }
    const omikujiData = {
      content: omikuji,
      timestamp: serverTimestamp(),
      site: SITE_ID
    }
    return addDoc(
      pathCollection(getFirebaseDb(), this.firestorePaths.omikujis),
      omikujiData
    )
  },

  omikujiStatisticsOnSnapshot(this: any, callback: (snap: any) => void) {
    if (!this.isAuthenticated) {
      console.log('not authenticated, getOmikujiStatistics skipped')
      return
    }
    return onSnapshot(
      pathDoc(getFirebaseDb(), this.firestorePaths.statisticsOmikuji),
      callback
    )
  },

  addPostCard(this: any, postCard: unknown) {
    if (!this.isAuthenticated) {
      return
    }
    if (!postCard) {
      this.$message({
        message: 'はがきの内容がありません',
        type: 'error'
      })
      return
    }
    const postCardData = {
      content: postCard,
      author: {
        uid: this.user.uid,
        email: this.user.email
      },
      timestamp: serverTimestamp(),
      site: SITE_ID
    }
    return addDoc(
      pathCollection(getFirebaseDb(), this.firestorePaths.postcards),
      postCardData
    )
  },

  getPostCardList(
    this: any,
    startAfterDoc?: QueryDocumentSnapshot<DocumentData>
  ) {
    if (!this.isAuthenticated) {
      return
    }
    const col = pathCollection(getFirebaseDb(), this.firestorePaths.postcards)
    const q = startAfterDoc
      ? query(
          col,
          orderBy('timestamp', 'desc'),
          limit(BACKUP_QUERY_LIMIT_NUM),
          startAfter(startAfterDoc)
        )
      : query(col, orderBy('timestamp', 'desc'), limit(BACKUP_QUERY_LIMIT_NUM))
    return getDocs(q)
  },

  getPostCardListOnSnapshot(this: any, callback: (snap: any) => void) {
    if (!this.isAuthenticated) {
      return
    }
    const q = query(
      pathCollection(getFirebaseDb(), this.firestorePaths.postcards),
      orderBy('timestamp', 'desc'),
      limit(BACKUP_QUERY_LIMIT_NUM)
    )
    return onSnapshot(q, callback)
  },

  loadUserConfig(this: any) {
    if (!this.isAuthenticated) {
      console.log('not authenticated. loadUserConfig skipped')
      return
    }
    const app = this
    return getDoc(
      pathDoc(getFirebaseDb(), this.firestorePaths.configs, CONFIG_DOCUMENT_ID)
    )
      .then(function (docSnap) {
        if (docSnap.exists()) {
          app.userConfig = docSnap.data()
        } else {
          console.log('not config use default')
          app.userConfig = {
            uid: app.user.uid,
            autoSave: true
          }
        }
      })
      .catch(function (error: unknown) {
        console.log(app.user.uid)
        console.error('Error getting document:', error)
      })
  },

  saveUserConfig(this: any) {
    if (!this.isAuthenticated) {
      console.log('not authenticated. saveUserConfig skipped')
      return
    }
    const app = this
    const userConfig = app.userConfig
    userConfig.uid = app.user.uid
    return setDoc(
      pathDoc(getFirebaseDb(), this.firestorePaths.configs, CONFIG_DOCUMENT_ID),
      app.userConfig
    )
      .then(function () {
        console.log('saveUserConfig success')
      })
      .catch(function (err: unknown) {
        console.log('saveUserConfig error:', err)
      })
  }
}
